import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelClientsEditAssessmentResolverErrorStatesEnum {
    GetExtendedIndividualFailed = ErrorStateScheduleEnum.PanelClientsEditAssessmentResolverStatesStartIndex,
    GetExtendedIndividualNotFound,
    GetPortalsFailed,
    GetPortalsInvalidData,
    GetFinancialQuestionnaireTypesFailed,
    GetFinancialQuestionnairesAllFailed,
    GetFinancialQuestionnairesAllInvalidData,
}
